import { View } from "binder"
import { ContentEditorViewModel } from "./contentEditor-viewModel"

export class ContentEditorView extends View<ContentEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-4C7EE088-5C0C-4C35-96B4-A38891AA3572"
    }
    loadHtml(): string {
        let element = require('./contentEditor.html').default;
        let style = require('./contentEditor.less');
        return element;
    }
    constructor() {
       super();
    }
}
